import { StatusDto } from '@/api/ApiClient';
import type { NodeType } from '@/types/tree/base';

/**
 * Mirrors server <c>FileMutationStatusPolicy</c> / <c>FileParentKind</c>.
 */
export type FileParentKind = 'sample' | 'activity' | 'shipping' | 'dataPackage' | 'communication';

export function nodeTypeToFileParentKind(nodeType: NodeType): FileParentKind | null {
  switch (nodeType) {
    case 'sample':
    case 'sampleInPackage':
    case 'sampleAggregate':
    case 'sampleSnapshot':
      return 'sample';
    case 'sampleActivity':
    case 'sampleActivityAggregate':
    case 'sampleActivityInPackage':
    case 'sampleActivitySnapshot':
    case 'projectActivity':
    case 'theoryActivity':
    case 'theoryActivityInPackage':
      return 'activity';
    case 'shipping':
      return 'shipping';
    case 'dataPackage':
    case 'simulationDataset':
      return 'dataPackage';
    case 'communication':
      return 'communication';
    default:
      return null;
  }
}

/** Whether the parent entity status allows file attach / metadata edit / delete. */
export function parentStatusAllowsFileMutation(kind: FileParentKind, status?: string): boolean {
  if (!status || status === StatusDto.Published) {
    return false;
  }

  switch (kind) {
    case 'shipping':
    case 'communication':
      return true;
    case 'dataPackage':
      return status === StatusDto.Pending;
    case 'sample':
    case 'activity':
      return status === StatusDto.Pending || status === StatusDto.New;
    default:
      return false;
  }
}
